import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { useNavigate } from "react-router-dom"
import { Dropdown, Modal } from 'react-bootstrap'
import Select from "react-select"

import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'

import { httpOk, GET, } from 'helpers/api'
import { checkFilter, findKeyFromArrayByValue, formatDate, formatMoney } from 'helpers/helpers'
import useDidMountEffect from "pages/parts/useDidMountEffect"
import Rightbar from "../cheques/Rightbar"

function Balance() {
	const { t } = useTranslation()
	const navigate = useNavigate()

	const initialFilter = {};

	const [warehouses, setWarehouses] = useState([])
	const [productTypes, setProductTypes] = useState([])
	const [categories, setCategories] = useState([])
	const [data, setData] = useState([])

	const [showModal, setShowModal] = useState({ show: false, data: {} })
	const [showHistoryModal, setShowHistoryModal] = useState({ show: false, data: {} })
	const [showRightBar, setShowRightBar] = useState(false)
	const [cheque, setCheque] = useState({})

	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [filterData, setFilterData] = useState({})
	const [pagination, setPagination] = useState({
		url: `/report-balance`,
		response: null
	})
	const [productsPagination, setProductsPagination] = useState({
		url: `/report-balance`,
		response: null
	})
	const [historyPagination, setHistoryPagination] = useState({
		url: `/report-balance`,
		response: null
	})

	async function searchWithFilter() {
		setFilterDataExist(checkFilter(filterData, initialFilter))

		const response = await GET(`/report-balance-by-category`, filterData, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ ...pagination, 'response': response.data })
			if (dropdownIsOpen) setDropdownIsOpen(false)
		}
	}

	async function toggleModal(bool, item = {}) {
		var url = `/report-balance-products-by-category?category_id=${item?.category_id}`
		if (bool) {
			const response = await GET(url, {}, { loader: true })
			if (httpOk(response)) {
				setShowModal({ show: true, data: response.data, category_id: item?.category_id })
				setProductsPagination({ ...productsPagination, url: url, 'response': response.data })
			}

		} else {
			setShowModal({ ...showModal, show: false })
		}
	}

	async function toggleHistoryModal(bool, item = {}) {
		var url = `/report-balance-history-by-category?balance_id=${item.balance_id}`
		if (bool) {
			const response = await GET(url, {}, { loader: true })
			if (httpOk(response)) {
				setShowHistoryModal({ show: bool, data: response.data, balance_id: item.balance_id })
				setHistoryPagination({ ...historyPagination, url: url, 'response': response.data })
				setShowModal({ ...showModal, show: !bool })
			}

		} else {
			setShowHistoryModal({ ...showHistoryModal, show: bool })
			setShowModal({ ...showModal, show: !bool })
		}
	}

	async function productsPaginate(page, size) {
		var url = `/report-balance-products-by-category?category_id=${showModal.category_id}&page=${page}`
		if (size) url += `&size=${size}`
		const response = await GET(url, {}, { loader: true })
		if (httpOk(response)) {
			setShowModal({ ...showModal, data: response.data })
			setProductsPagination({ ...productsPagination, url: url, 'response': response.data })
		}
	}

	async function historyPaginate(page, size) {
		var url = `/report-balance-history-by-category?balance_id=${showHistoryModal.balance_id}&page=${page}`
		if (size) url += `&size=${size}`
		const response = await GET(url, {}, { loader: true })
		if (httpOk(response)) {
			setShowHistoryModal({ ...showHistoryModal, data: response.data })
			setHistoryPagination({ ...historyPagination, url: url, 'response': response.data })
		}
	}

	async function redirect(item) {
		if (item.movement_type_id === 1) {
			const response = await GET(`/cheques/${item.entity_id}`, {}, { loader: true })
			if (httpOk(response)) {
				setCheque(response.data)
				setShowRightBar(true)
			}
		}
		if (item.movement_type_id === 2) {
			navigate(`/documents-in/preview/${item.entity_id}`)
		}
		if (item.movement_type_id === 3 || item.movement_type_id === 4) {
			navigate(`/documents-preparation/preview/${item.entity_id}`)
		}
		if (item.movement_type_id === 5) {
			navigate(`/write-off/preview/${item.entity_id}`)
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	function resetFilter() {
		setFilterData({ wms_id: warehouses[0]['id'] })

		searchWithFilter();
	}

	function getMovementQuantityClass(item) {
		if (item.movement_name === t('return')) {
			return 'text-warning'
		}

		return item.movement_transaction_type === 'plus' ? 'text-success' : 'text-danger'
	}

	async function paginate(page, size) {
		setFilterData({ ...filterData, 'page': page, 'size': size })
	}

	async function getWms() {
		const response = await GET('/helper/wms')
		if (httpOk(response)) {
			setWarehouses(response.data)
			setFilterData({ ...filterData, wms_id: response.data[0].id })
		}
	}

	async function getProductTypes() {
		const response = await GET('/helper/products-types')
		if (httpOk(response)) setProductTypes(response.data)
	}

	async function getCategories() {
		const response = await GET('/helper/categories')
		if (httpOk(response)) setCategories(response.data)
	}

	useEffect(() => {
		getWms()
		getProductTypes()
		getCategories()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps


	useDidMountEffect(() => {
		searchWithFilter(false)
	}, [filterData.search, filterData.page, warehouses, filterData.size]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header">
				<h4 className="vertical-center h-100">
					{t('balance_by_category')} [{data?.data?.length}]
				</h4>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex gap-2">
							<FilterSearch
								filterData={filterData}
								setFilterData={setFilterData}>
							</FilterSearch>

							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('warehouses')}</label>
												<Select
													isClearable
													options={warehouses}
													value={warehouses.find(option => option.id === filterData.wms_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'wms_id': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('type')}</label>
												<Select
													isClearable
													options={productTypes}
													value={productTypes.find(option => option.id === filterData.product_type_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'product_type_id': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('category')}</label>
												<Select
													isClearable
													options={categories}
													value={categories.find(option => option.id === filterData.category_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'category_id': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end">
													<button className="btn btn-secondary me-2" onClick={() => setDropdownIsOpen(false)}>{t('cancel')}</button>
													<button className="btn btn-primary" onClick={() => searchWithFilter()}>{t('apply')}</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{filterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
								{filterData.wms_id &&
									<span className="me-2">
										<b>{t('warehouse')}: </b>
										{findKeyFromArrayByValue(warehouses, 'id', filterData.wms_id, 'name')}
									</span>
								}
								{filterData.product_type_id &&
									<span className="me-2">
										<b>{t('type')}: </b>
										{findKeyFromArrayByValue(productTypes, 'id', filterData.product_type_id, 'name')}
									</span>
								}
								{filterData.category_id &&
									<span className="me-2">
										<b>{t('category')}: </b>
										{findKeyFromArrayByValue(categories, 'id', filterData.category_id, 'name')}
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>
									{t('reset')}
								</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '70%' }}>{t('product_name')}</th>
									{/* <th style={{ 'width': '60%' }}></th> */}
									<th style={{ 'width': '10%' }} className="text-end">{t('products')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('balance2')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('amount')}</th>
									{/* <th style={{ 'minWidth': '33px' }}></th> */}
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr className="tr-middle" key={index}>
										<td className="text-center">
											{item.row_number}
										</td>
										<td className="text-primary cursor" onClick={() => toggleModal(true, item)}>
											{item.category_name}
										</td>
										<td className="text-end">{formatMoney(item.total_products)}</td>
										<td className="text-end">{formatMoney(item.total_balance, 2)}</td>
										<td className="text-end">{formatMoney(item.total_amount)}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={paginate}>
						</FilterPagination>
					}
				</div>
			</div>

			<Modal show={showModal.show} animation={false} centered dialogClassName="update-modal-width"
				onHide={() => toggleModal(false)} size="xl">
				<Modal.Header closeButton>
					<Modal.Title>
						{t('balance2')} [{showModal.data.total}]
					</Modal.Title>
				</Modal.Header>

				<Modal.Body>


					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '50%' }}>{t('name2')}</th>
									<th style={{ 'width': '10%' }}>{t('id')}</th>
									<th style={{ 'width': '20%' }}>{t('type')}</th>
									<th style={{ 'width': '10%' }}>{t('warehouse')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('balance2')}</th>
									<th style={{ 'minWidth': '130px' }} className="text-center">{t('date')}</th>
								</tr>
							</thead>
							<tbody>
								{showModal?.data?.data?.map((item, index) => (
									<tr className="tr-middle" key={index}>
										<td className="text-center">{item.row_number}</td>
										<td className="text-primary cursor" onClick={() => toggleHistoryModal(true, item)}>{item.product_name}</td>
										<td>{item.element_id}</td>
										<td>{item.product_type_name}</td>
										<td>{item.wms_name}</td>
										<td className="text-end">{formatMoney(item.balance, 2)}</td>
										<td className="text-center">{formatDate(item.created_at, 'dd.MM.yyyy HH:mm')}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={productsPagination}
							paginate={productsPaginate}>
						</FilterPagination>
					}
				</Modal.Body>
			</Modal>

			<Modal show={showHistoryModal.show} animation={false} centered dialogClassName="update-modal-width"
				onHide={() => toggleHistoryModal(false)} size="xl">
				<Modal.Header closeButton>
					<Modal.Title>
						{t('balance2')} [{showHistoryModal.data.total}]
					</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '20%' }}>{t('name2')}</th>
									<th style={{ 'width': '10%' }}>{t('id')}</th>
									<th style={{ 'width': '10%' }}>{t('type')}</th>
									<th style={{ 'width': '10%' }}>{t('warehouse')}</th>
									<th style={{ 'width': '10%' }}>{t('type')}</th>
									<th style={{ 'minWidth': '70px' }} className="text-end">{t('quantity')}</th>
									{/* <th style={{ 'minWidth': '70px' }} className="text-end">{t('balance2')}</th>  */}
									<th style={{ 'minWidth': '80px' }} className="text-end">{t('price')}</th>
									<th style={{ 'minWidth': '100px' }} className="text-end">{t('amount')}</th>
									<th style={{ 'minWidth': '130px' }} className="text-center">{t('date')}</th>
								</tr>
							</thead>
							<tbody>
								{showHistoryModal?.data?.data?.map((item, index) => (
									<tr className="tr-middle" key={index}>
										<td className="text-center">{item.row_number}</td>
										<td className="text-primary cursor" onClick={() => redirect(item)}>{item.product_name}</td>
										<td>{item.element_id}</td>
										<td>{item.product_type_name}</td>
										<td>{item.wms_name}</td>
										<td>{item.movement_name}</td>
										<td className={`text-end ${getMovementQuantityClass(item)}`}>{formatMoney(item.quantity, 3)}</td>
										{/* <td className="text-end">{formatMoney(item.balance, 2)}</td> */}
										<td className="text-end">{formatMoney(item.cost_price)}</td>
										<td className="text-end">{formatMoney(item.total_amount)}</td>
										<td className="text-center">{formatDate(item.created_at, 'dd.MM.yyyy HH:mm')}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={historyPagination}
							paginate={historyPaginate}>
						</FilterPagination>
					}
				</Modal.Body>
			</Modal>

			<Rightbar
				showRightBar={showRightBar}
				setShowRightBar={setShowRightBar}	
				selectedItem={cheque}>
			</Rightbar>
		</>
	)
}

export default Balance
